var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4287 7.59614C9.53638 7.11992 7.92188 7.04056 5.9249 5.92939C7.92188 4.8579 9.53638 4.73884 10.4287 4.26263C10.896 4.02453 11.1935 3.58799 10.8536 3.0324C10.5137 2.4768 9.91883 2.51651 9.45144 2.7943C8.60166 3.23082 7.70943 4.50073 5.71245 5.61192C5.71245 3.38957 6.43476 2.00059 6.43476 1.04816C6.43476 0.492573 6.17982 0.0163574 5.50002 0.0163574C4.8202 0.0163574 4.56526 0.492573 4.56526 1.04816C4.56526 2.00059 5.28757 3.38957 5.28757 5.61192C3.2906 4.50073 2.39835 3.23082 1.54858 2.7943C1.08121 2.51651 0.528856 2.4768 0.146458 3.0324C-0.19345 3.58799 0.10397 4.02453 0.571344 4.26263C1.4636 4.73884 3.07817 4.8579 5.07512 5.92939C3.07817 7.04056 1.4636 7.11992 0.571344 7.59614C0.10397 7.87393 -0.19345 8.31047 0.146458 8.86606C0.528856 9.42164 1.08121 9.38197 1.54858 9.10418C2.39835 8.62795 3.2906 7.35802 5.28757 6.24687C5.28757 8.46924 4.56526 9.89786 4.56526 10.8503C4.56526 11.3662 4.8202 11.8424 5.50002 11.8424C6.17982 11.8424 6.43476 11.3662 6.43476 10.8503C6.43476 9.89786 5.71245 8.46924 5.71245 6.24687C7.70943 7.35802 8.60166 8.62795 9.45144 9.10418C9.91883 9.38197 10.5137 9.42164 10.8536 8.86606C11.1935 8.31047 10.896 7.87393 10.4287 7.59614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerIcon);
export default __webpack_public_path__ + "static/media/flower-icon.9c2eddb0d98b75630136fb301c7c74c8.svg";
export { ForwardRef as ReactComponent };